export default {
    LOAD_FLEET(state, fleet) {
        state.items = fleet;
    }
}
